import {Module} from "../common/Module";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {Nullable} from "../common/Nullable";
import {isPrivileged} from "../../config/Privileges";
import {ReportingAreaType} from "./ReportingAreaType";

/**
 * module of the customer revenue report (Kunden-Umsatz-Report).
 *
 * shows the revenue generated per customer, layered by the projects of
 * each customer. the identifier matches the backend module
 * "customer_revenue_report" of the reporting area.
 */
export const CustomerRevenueReportModule: Module = {
    identifier: "customer_revenue_report",
    isPrivileged(
        authUser: Nullable<AuthenticatedUser>,
        privilege: string,
        privilegeIdentifier: string | undefined
    ): boolean {
        return isPrivileged(
            authUser,
            ReportingAreaType,
            CustomerRevenueReportModule.identifier,
            privilege
        );
    }
};
